<template>
  <div class="IncrementalData-fieldWrap">
    <div class="IncrementalData-field">
      <p class="IncrementalData-supportingText">
        Tell us which gender you identify with to discover targeted opportunities.
      </p>
      <div
        class="IncrementalData-question"
        data-rmpdev-selector="gender-field"
      >
        <label
          for="gender"
          class="IncrementalData-questionText"
        >
          What is your gender? *
        </label>
        <div class="IncrementalData-questionField">
          <form-autocomplete
            v-model="fields.gender"
            :required="true"
            :items="genders"
            :searchable="false"
            :error="validateStatus({ field: v$.fields.gender, serverKey: 'gender', label: 'Gender' })"
            :manual-validate="validateAll"
            placeholder="Select your gender"
            data-rmpdev-field-selector="gender"
            @change="validateBlur({ field: v$.fields.gender, serverKey: 'gender' })"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import FormAutocomplete from '@/components/form/autocomplete-select';
import useVuelidate from '@vuelidate/core';
import incrementalMixin from '../mixins/incremental-data-field-mixin';

export default {

  components: {
    FormAutocomplete,
  },
  mixins: [incrementalMixin],

  data() {
    return {
      v$: useVuelidate(),
      fields: {
        gender: null,
      },
      fieldName: 'gender',
    };
  },

  computed: {
    ...mapState('entities', {
      genders: (state) => state.genders,
    }),
    updatePayload() {
      return {
        gender: this.fields.gender.value,
      };
    },
  },

  mounted() {
    this.getGenders();
  },

  methods: {
    ...mapActions('entities', {
      getGenders: 'getGenders',
    }),
  },
};
</script>
